import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import "./App.css";
import FluidSimulation from './component/Fluid/FluidSimulation';
import AnimatedCursor from 'react-animated-cursor';
import ProductsPage from './component/ProductsPage/ProductsPage';
import ProjectDetailsPage from './component/ProjectDetailsPage/ProjectDetailsPage';
import ProductDetailPage from './components/ProductDetailPage/ProductDetailPage';
import AboutUs from './component/AboutUs/AboutUs';
import Contact from './component/Contact/Contact';
const App = () => {
  return (
    <>
      <AnimatedCursor
        innerSize={8}
        outerSize={35}
        innerScale={1}
        outerScale={1.7}
        outerAlpha={0}
        hasBlendMode={true}
        innerStyle={{
          backgroundColor: '#ffffff'
        }}
        outerStyle={{
          border: '3px solid #ffffff'
        }}
        clickables={[
          'a',
          'input[type="text"]',
          'input[type="email"]',
          'input[type="number"]',
          'input[type="submit"]',
          'input[type="image"]',
          'label[for]',
          'select',
          'textarea',
          'button',
          '.link'
        ]}
      />
      
      <Router>
        <Routes>
          <Route path="/" element={<FluidSimulation />} />
          <Route path="/projects" element={<ProductsPage />} />
          <Route path="/project/:slug" element={<ProjectDetailsPage />} />
          <Route path="/product/:id" element={<ProductDetailPage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Router>
    </>
  )
}
export default App
